var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"type":"bar","options":_vm.columnChart.options,"series":_vm.columnChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }